import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleFeaturesModal, PAP_STEPS } from 'project/ducks/features';
import { PACKAGE_ITEMS, LEGACY_PACKAGE_ITEMS } from 'pap/ducks/workflow';
import { canUpgrade } from 'project/utils';
import Features from 'project/components/features';
import sortBy from 'lodash/sortBy';

/* Get list of features to be displayed from `PACKAGE_ITEMS`
   (or `LEGACY_PACKAGE_ITEMS` for legacy projects) */
const getFeatures = (project) => {
  let features = [];

  if (project.is_legacy) {
    LEGACY_PACKAGE_ITEMS.forEach((item) => {
      const itemFeatures = project.features.filter(({ feature }) => (
        feature.name === item.name
      )).map(f => f.feature);
      features = features.concat(itemFeatures);
    });
  } else {
    PACKAGE_ITEMS.forEach((item) => {
      if (!Object.keys(PAP_STEPS).includes(item.step) || item.ignoreOnSettings) {
        return;
      }
      const itemFeatures = project.features.filter(({ feature }) => (
        [feature.name, feature.group].includes(item.name)
      )).map(f => f.feature);

      features = features.concat(itemFeatures);
    });
  }

  /* active features first */
  return sortBy(features, f => !f.active);
};

const mapStateToProps = (state) => {
  const project = state.project.projectPage.project.data;
  const canEdit = canUpgrade(state);

  return {
    canEdit,
    project,
    features: getFeatures(project),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleModal: toggleFeaturesModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Features);



// WEBPACK FOOTER //
// ./project/containers/features.js